import { render, staticRenderFns } from "./SyncStrava.vue?vue&type=template&id=1db28ecc&scoped=true"
import script from "./SyncStrava.vue?vue&type=script&lang=js"
export * from "./SyncStrava.vue?vue&type=script&lang=js"
import style0 from "./SyncStrava.vue?vue&type=style&index=0&id=1db28ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db28ecc",
  null
  
)

export default component.exports